import { useRef } from "react";
import { Link } from "react-router-dom";
import { Back, gsap } from "gsap";

import { color } from "../designTokens";

const WorkTile = ({ project }) => {
  const tileRef = useRef();

  const showEffects = () => {
    gsap.to(tileRef.current.children[0], {
      top: "-25%",
      duration: 0.6,
      ease: Back.easeOut.config(0.8),
    });

    gsap.to(tileRef.current.children[1], {
      color: color.primary,
    });
  };

  const hideEffects = () => {
    gsap.to(tileRef.current.children[0], {
      top: "-100%",
      duration: 0.6,
    });

    gsap.to(tileRef.current.children[1], {
      color: color.secondary,
    });
  };

  return (
    <div
      className="work-tile"
      onMouseEnter={showEffects}
      onMouseLeave={hideEffects}
      ref={tileRef}
    >
      <svg
        className="work-tile__bg-blob"
        width="503"
        height="473"
        viewBox="0 0 629 591"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M612.734 210.93C654.594 318.509 611.077 434.963 524.7 511.544C438.053 588.364 317.825 616.64 214.839 563.697C89.3473 499.185 -23.1932 382.383 4.19255 243.964C33.0314 98.1993 177.754 9.26059 326.126 1.20657C456.813 -5.88751 565.274 88.9585 612.734 210.93Z"
          fill="black"
        />
      </svg>
      <div className="work-tile__project-details">
        <div className="work-tile__name-p-desc">
          <h4 className="work-tile__project-name">{project.name}</h4>
          <div className="work-tile__project-desc text-R-medium">
            {project.desc}
          </div>
        </div>
        <div className="work-tile__links">
          <Link to={project.demo} target="_blank">
            <svg
              width="81"
              height="81"
              viewBox="0 0 81 81"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40.5703" cy="40.4297" r="40.4297" fill="black" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M40.5703 56.6016C44.8594 56.6016 48.9727 54.8977 52.0056 51.8649C55.0384 48.8321 56.7422 44.7187 56.7422 40.4297C56.7422 36.1406 55.0384 32.0273 52.0056 28.9944C48.9727 25.9616 44.8594 24.2578 40.5703 24.2578C36.2813 24.2578 32.1679 25.9616 29.1351 28.9944C26.1023 32.0273 24.3984 36.1406 24.3984 40.4297C24.3984 44.7187 26.1023 48.8321 29.1351 51.8649C32.1679 54.8977 36.2813 56.6016 40.5703 56.6016ZM29.1125 36.4413C29.8631 34.2919 31.2023 32.3965 32.9776 30.9712C33.5194 31.7979 34.4533 32.3438 35.5166 32.3438C36.3208 32.3438 37.0921 32.6632 37.6607 33.2319C38.2294 33.8005 38.5488 34.5718 38.5488 35.376V36.3867C38.5488 37.459 38.9748 38.4873 39.733 39.2455C40.4912 40.0037 41.5195 40.4297 42.5918 40.4297C43.6641 40.4297 44.6924 40.0037 45.4506 39.2455C46.2088 38.4873 46.6348 37.459 46.6348 36.3867C46.6344 35.4819 46.9376 34.6032 47.4958 33.8911C48.0539 33.179 48.8348 32.6748 49.7135 32.459C51.6426 34.6658 52.7037 37.4986 52.6992 40.4297C52.6992 41.117 52.6426 41.7942 52.5314 42.4512H50.6777C49.6055 42.4512 48.5771 42.8771 47.8189 43.6353C47.0607 44.3935 46.6348 45.4219 46.6348 46.4941V50.9353C44.7918 52.0017 42.6996 52.5617 40.5703 52.5586V48.5156C40.5703 47.4434 40.1444 46.415 39.3862 45.6568C38.6279 44.8986 37.5996 44.4727 36.5273 44.4727C35.4551 44.4727 34.4267 44.0467 33.6685 43.2885C32.9103 42.5303 32.4844 41.5019 32.4844 40.4297C32.4847 39.4735 32.1462 38.5482 31.5289 37.818C30.9116 37.0878 30.0554 36.6 29.1125 36.4413Z"
                fill="#B7AB98"
              />
            </svg>
          </Link>
          <Link to={project.code} target="_blank">
            <svg
              width="81"
              height="81"
              viewBox="0 0 81 81"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40.5703" cy="40.4609" r="40.4297" fill="black" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M45.2521 26.4133C45.5041 26.4971 45.7371 26.6297 45.9377 26.8036C46.1384 26.9775 46.3029 27.1893 46.4217 27.4267C46.5405 27.6642 46.6114 27.9228 46.6303 28.1876C46.6492 28.4525 46.6157 28.7185 46.5317 28.9704L38.4458 53.2282C38.2764 53.737 37.9118 54.1577 37.4322 54.3976C36.9526 54.6376 36.3974 54.6773 35.8886 54.5078C35.3798 54.3384 34.9592 53.9738 34.7192 53.4943C34.4792 53.0147 34.4396 52.4594 34.609 51.9507L42.6949 27.6928C42.7788 27.4409 42.9114 27.2079 43.0853 27.0072C43.2592 26.8066 43.471 26.6421 43.7084 26.5233C43.9459 26.4044 44.2045 26.3336 44.4693 26.3147C44.7342 26.2958 45.0002 26.3293 45.2521 26.4133ZM31.8921 32.9669C32.2711 33.346 32.484 33.8601 32.484 34.3961C32.484 34.9321 32.2711 35.4462 31.8921 35.8253L27.2569 40.4605L31.8921 45.0958C32.0852 45.2823 32.2392 45.5053 32.3452 45.752C32.4511 45.9986 32.5069 46.2639 32.5092 46.5323C32.5115 46.8007 32.4604 47.0669 32.3587 47.3153C32.2571 47.5637 32.107 47.7894 31.9172 47.9792C31.7274 48.169 31.5017 48.3191 31.2533 48.4208C31.0048 48.5224 30.7386 48.5736 30.4702 48.5712C30.2018 48.5689 29.9366 48.5131 29.6899 48.4072C29.4433 48.3013 29.2202 48.1473 29.0338 47.9542L22.9693 41.8897C22.5903 41.5106 22.3774 40.9966 22.3774 40.4605C22.3774 39.9245 22.5903 39.4104 22.9693 39.0314L29.0338 32.9669C29.4128 32.5879 29.9269 32.375 30.4629 32.375C30.999 32.375 31.5131 32.5879 31.8921 32.9669ZM49.2486 32.9669C49.6277 32.5879 50.1418 32.375 50.6778 32.375C51.2138 32.375 51.7279 32.5879 52.107 32.9669L58.1714 39.0314C58.5504 39.4104 58.7633 39.9245 58.7633 40.4605C58.7633 40.9966 58.5504 41.5106 58.1714 41.8897L52.107 47.9542C51.9205 48.1473 51.6974 48.3013 51.4508 48.4072C51.2042 48.5131 50.9389 48.5689 50.6705 48.5712C50.4021 48.5736 50.1359 48.5224 49.8875 48.4208C49.639 48.3191 49.4133 48.169 49.2235 47.9792C49.0337 47.7894 48.8836 47.5637 48.782 47.3153C48.6804 47.0669 48.6292 46.8007 48.6315 46.5323C48.6339 46.2639 48.6896 45.9986 48.7956 45.752C48.9015 45.5053 49.0555 45.2823 49.2486 45.0958L53.8839 40.4605L49.2486 35.8253C48.8696 35.4462 48.6567 34.9321 48.6567 34.3961C48.6567 33.8601 48.8696 33.346 49.2486 32.9669Z"
                fill="#B7AB98"
              />
            </svg>
          </Link>
        </div>
      </div>
      <img src={project.image} alt="" />
    </div>
  );
};

export default WorkTile;
